// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TriplePictures_wrapper__0m21R","column":"TriplePictures_column__NdEtq","image":"TriplePictures_image__8JrKK"};